// extracted by mini-css-extract-plugin
module.exports = {"landing":"uOKLFTsLDisq6ht-LHC0aw==","back":"RmG-4JsyE6mb6qxTxPHdRw=="};